/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import { fetchAggregate } from './reducers/aggregate';
import { publicReviews } from './reducers/publicReviews';
import { aiReview } from './reducers/aiReview';
import { postReviewVote } from './reducers/reviewVote';
import { postAIReviewVote } from './reducers/aiReviewVote';
import { postReviewFlag } from './reducers/reviewFlag';
import { putReview } from './reducers/putReview';
import { fetchOrder } from './reducers/fetchOrder';
import { fetchReview } from './reducers/fetchReview';

// Used by inventory pages for aggregate bar and review sections
export const externalRatingReviewsReducers = combineReducers({
    publicReviews,
    aiReview,
    postReviewVote,
    postReviewFlag,
    fetchAggregate,
    postAIReviewVote,
});

const reviewWizardReducers = combineReducers({
    fetchReview,
    putReview,
    fetchOrder,
});

export default function reducers() {
    return {
        ratingReviews: reviewWizardReducers,
    };
}
